if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

import {
  // AngleTool,
  // ArrowAnnotateTool,
  // BidirectionalTool,
  // CircleRoiTool,
  // CobbAngleTool,
  EllipticalRoiTool,
  FreehandRoiTool,
  // LengthTool,
  // ProbeTool,
  RectangleRoiTool,
  // TextMarkerTool,
  /**
   * RXTO
   */
  // AtelectasiaTool,
  // CardiomegaliaTool,
  // CongestivoOrEdemaTool,
  // DestaqueHilarTool,
  // DispositivosMedicosTool,
  // EfusaoTool,
  // FracturaTool,
  // LesaoPulmonarTool,
  // MediastinoAmpliadoTool,
  // OpacidadePulmonarTool,
  // OutrosAndSpecifyTool,
  // PleuralOutroTool,
  // PneumoniaOrConsolidacaoTool,
  // PneumotoraxTool,
  /**
   * CITO
   */
  // AdenocarcinomaInvasorTool,
  // AisTool,
  // AscHTool,
  // AscUsTool,
  // CelulaGrandularNormalTool,
  // CelulaPavimentosaNormalTool,
  // CgafnTool,
  // CgaTool,
  // CpcTool,
  // HsilTool,
  // LsilTool,
  // ZonaTransformacaoTool,
  /**
   * COLP
   */
  // IodonegativoTool,
  // PadroesMosaicoTool,
  // PontuacoesTool,
  // RegioesAcetowhiteTool,
  // VascularizacaoAnormalTool,
  /**
   * GLAU
   */
  // AtrofiaTool,
  // CopoOticoTool,
  // DiscoOticoTool,
  // NervoOticoTool,
  // TesteGlaucomaTool,
  /**
   * OTHER
   */
  // VerticalLineTool,
  // HorizontalLineTool,
  // ClockTool,
  // DefaultTool,
} from './tools/annotation/index.js';
// import {
//   BrushTool,
//   SphericalBrushTool,
//   FreehandScissorsTool,
//   RectangleScissorsTool,
//   CircleScissorsTool,
//   CorrectionScissorsTool,
// } from './tools/segmentation/index.js';
import {
  // CrosshairsTool,
  // DoubleTapFitToWindowTool,
  DragProbeTool,
  EraserTool,
  // FreehandRoiSculptorTool,
  MagnifyTool,
  // OverlayTool,
  // OrientationMarkersTool,
  // PanMultiTouchTool,
  PanTool,
  // ReferenceLinesTool,
  RotateTool,
  // RotateTouchTool,
  // ScaleOverlayTool,
  // StackScrollMouseWheelTool,
  // StackScrollMultiTouchTool,
  // StackScrollTool,
  // WwwcRegionTool,
  WwwcTool,
  ZoomMouseWheelTool,
  ZoomTool,
  // ZoomTouchPinchTool,
} from './tools/index.js';

import { default as init } from './init.js';

// ~~~~~~ STACK TOOLS ~~~~~ //
import { default as stackPrefetch } from './stackTools/stackPrefetch.js';
import { default as stackRenderers } from './stackTools/stackRenderers.js';
import { playClip, stopClip } from './stackTools/playClip.js';

// ~~~~~~ STATE MANAGEMENT ~~~~~ //
import { default as store } from './store/index.js';
import { getModule } from './store/index.js';

import { default as getToolForElement } from './store/getToolForElement.js';
import { addTool, addToolForElement } from './store/addTool.js';
import { removeTool, removeToolForElement } from './store/removeTool.js';
import {
  setToolOptions,
  setToolOptionsForElement,
} from './store/setToolOptions.js';
import {
  setToolActive,
  setToolActiveForElement,
  setToolEnabled,
  setToolEnabledForElement,
  setToolDisabled,
  setToolDisabledForElement,
  setToolPassive,
  setToolPassiveForElement,
} from './store/setToolMode.js';
import isToolActiveForElement from './store/isToolActiveForElement';
import {
  addToolState,
  getToolState,
  removeToolState,
  clearToolState,
  setElementToolStateManager,
  getElementToolStateManager,
} from './stateManagement/toolState.js';
import { default as textStyle } from './stateManagement/textStyle.js';
import { default as toolStyle } from './stateManagement/toolStyle.js';
import { default as toolColors } from './stateManagement/toolColors.js';
import { default as toolCoordinates } from './stateManagement/toolCoordinates.js';
import { default as numberOfAnnotations } from './stateManagement/numberOfAnnotations.js';
import { default as activeIndex } from './stateManagement/activeIndex.js';
import { default as activeAnnotation } from './stateManagement/activeAnnotation.js';
import { default as movingAnnotations } from './stateManagement/movingAnnotations.js';
import { default as comparingImages } from './stateManagement/comparingImages.js';
import {
  stackSpecificStateManager,
  newStackSpecificToolStateManager,
  addStackStateManager,
} from './stateManagement/stackSpecificStateManager.js';
import { default as loadHandlerManager } from './stateManagement/loadHandlerManager.js';
import {
  newImageIdSpecificToolStateManager,
  globalImageIdSpecificToolStateManager,
} from './stateManagement/imageIdSpecificStateManager.js';
import {
  newFrameOfReferenceSpecificToolStateManager,
  globalFrameOfReferenceSpecificToolStateManager,
} from './stateManagement/frameOfReferenceStateManager.js';
import { forceEnabledElementResize } from './eventListeners/windowResizeHandler.js';

// ~~~~~~ ORIENTATION  ~~~~~ //
import { default as orientation } from './orientation/index.js';

// ~~~~~~ CANVAS EXPORT  ~~~~~ //
import { default as SaveAs } from './util/SaveAs.js';
import {
  enable as enableLogger,
  disable as disableLogger,
} from './util/logger.js';

// ~~~~~~ THIRD PARTY SUPPORT  ~~~~~ //
import { default as register } from './thirdParty/register.js';
import { default as registerSome } from './thirdParty/registerSome.js';

// ~~~~~~ SYNCHRONIZERS ~~~~~ //
import { default as wwwcSynchronizer } from './synchronization/wwwcSynchronizer.js';
import { default as updateImageSynchronizer } from './synchronization/updateImageSynchronizer.js';
import { default as Synchronizer } from './synchronization/Synchronizer.js';
import { default as stackScrollSynchronizer } from './synchronization/stackScrollSynchronizer.js';
import { default as stackImagePositionSynchronizer } from './synchronization/stackImagePositionSynchronizer.js';
import { default as stackImagePositionOffsetSynchronizer } from './synchronization/stackImagePositionOffsetSynchronizer.js';
import { default as stackImageIndexSynchronizer } from './synchronization/stackImageIndexSynchronizer.js';
import { default as panZoomSynchronizer } from './synchronization/panZoomSynchronizer.js';

// ~~~~~~ REQUEST POOL MANAGER  ~~~~~ //
import { default as requestPoolManager } from './requestPool/requestPoolManager.js';

import { default as external } from './externalModules.js';
import { default as EVENTS } from './events.js';
import { default as version } from './version.js';

import importInternal from './importInternal.js';

const cornerstoneTools = {
  // ~~~ TOOLS
  // ~ Annotation Tools
  // AngleTool,
  // ArrowAnnotateTool,
  // BidirectionalTool,
  // CircleRoiTool,
  // CobbAngleTool,
  EllipticalRoiTool,
  FreehandRoiTool,
  // LengthTool,
  // ProbeTool,
  RectangleRoiTool,
  // TextMarkerTool,
  // /**
  //  * RXTO
  //  */
  // AtelectasiaTool,
  // CardiomegaliaTool,
  // CongestivoOrEdemaTool,
  // DestaqueHilarTool,
  // DispositivosMedicosTool,
  // EfusaoTool,
  // FracturaTool,
  // LesaoPulmonarTool,
  // MediastinoAmpliadoTool,
  // OpacidadePulmonarTool,
  // OutrosAndSpecifyTool,
  // PleuralOutroTool,
  // PneumoniaOrConsolidacaoTool,
  // PneumotoraxTool,
  // /**
  //  * CITO
  //  */
  // AdenocarcinomaInvasorTool,
  // AisTool,
  // AscHTool,
  // AscUsTool,
  // CelulaGrandularNormalTool,
  // CelulaPavimentosaNormalTool,
  // CgafnTool,
  // CgaTool,
  // CpcTool,
  // HsilTool,
  // LsilTool,
  // ZonaTransformacaoTool,
  // /**
  //  * COLP
  //  */
  // IodonegativoTool,
  // PadroesMosaicoTool,
  // PontuacoesTool,
  // RegioesAcetowhiteTool,
  // VascularizacaoAnormalTool,
  // /**
  //  * GLAU
  //  */
  // AtrofiaTool,
  // CopoOticoTool,
  // DiscoOticoTool,
  // NervoOticoTool,
  // TesteGlaucomaTool,
  // /**
  //  * OTHER
  //  */
  // // VerticalLineTool,
  // // HorizontalLineTool,
  // // ClockTool,
  // DefaultTool,
  // ~ Segmentation Tools
  // BrushTool,
  // SphericalBrushTool,
  // RectangleScissorsTool,
  // FreehandScissorsTool,
  // CircleScissorsTool,
  // CorrectionScissorsTool,
  // ~ Tools
  // CrosshairsTool,
  // DoubleTapFitToWindowTool,
  DragProbeTool,
  EraserTool,
  // FreehandRoiSculptorTool,
  MagnifyTool,
  // OverlayTool,
  // OrientationMarkersTool,
  // PanMultiTouchTool,
  PanTool,
  // ReferenceLinesTool,
  RotateTool,
  // RotateTouchTool,
  // ScaleOverlayTool,
  // StackScrollMouseWheelTool,
  // StackScrollMultiTouchTool,
  // StackScrollTool,
  // WwwcRegionTool,
  WwwcTool,
  ZoomMouseWheelTool,
  ZoomTool,
  // ZoomTouchPinchTool,
  init,
  stackPrefetch,
  stackRenderers,
  playClip,
  stopClip,
  store,
  getModule,
  getToolForElement,
  addTool,
  addToolForElement,
  removeTool,
  removeToolForElement,
  setToolOptions,
  setToolOptionsForElement,
  isToolActiveForElement,
  setToolActive,
  setToolActiveForElement,
  setToolEnabled,
  setToolEnabledForElement,
  setToolDisabled,
  setToolDisabledForElement,
  setToolPassive,
  setToolPassiveForElement,
  addToolState,
  getToolState,
  removeToolState,
  clearToolState,
  setElementToolStateManager,
  getElementToolStateManager,
  textStyle,
  toolStyle,
  toolColors,
  toolCoordinates,
  numberOfAnnotations,
  activeIndex,
  activeAnnotation,
  movingAnnotations,
  comparingImages,
  stackSpecificStateManager,
  newStackSpecificToolStateManager,
  addStackStateManager,
  loadHandlerManager,
  newImageIdSpecificToolStateManager,
  globalImageIdSpecificToolStateManager,
  newFrameOfReferenceSpecificToolStateManager,
  globalFrameOfReferenceSpecificToolStateManager,
  forceEnabledElementResize,
  orientation,
  SaveAs,
  enableLogger,
  disableLogger,
  importInternal,
  import: importInternal,
  register,
  registerSome,
  wwwcSynchronizer,
  updateImageSynchronizer,
  Synchronizer,
  stackScrollSynchronizer,
  stackImagePositionSynchronizer,
  stackImagePositionOffsetSynchronizer,
  stackImageIndexSynchronizer,
  panZoomSynchronizer,
  requestPoolManager,
  external,
  EVENTS,
  version,
};

// Named Exports
export {
  // ~~~ TOOLS
  // ~ Annotation Tools
  // AngleTool,
  // ArrowAnnotateTool,
  // BidirectionalTool,
  // CircleRoiTool,
  // CobbAngleTool,
  EllipticalRoiTool,
  FreehandRoiTool,
  // LengthTool,
  // ProbeTool,
  RectangleRoiTool,
  // TextMarkerTool,
  // /**
  //  * RXTO
  //  */
  // AtelectasiaTool,
  // CardiomegaliaTool,
  // CongestivoOrEdemaTool,
  // DestaqueHilarTool,
  // DispositivosMedicosTool,
  // EfusaoTool,
  // FracturaTool,
  // LesaoPulmonarTool,
  // MediastinoAmpliadoTool,
  // OpacidadePulmonarTool,
  // OutrosAndSpecifyTool,
  // PleuralOutroTool,
  // PneumoniaOrConsolidacaoTool,
  // PneumotoraxTool,
  // /**
  //  * CITO
  //  */
  // AdenocarcinomaInvasorTool,
  // AisTool,
  // AscHTool,
  // AscUsTool,
  // CelulaGrandularNormalTool,
  // CelulaPavimentosaNormalTool,
  // CgafnTool,
  // CgaTool,
  // CpcTool,
  // HsilTool,
  // LsilTool,
  // ZonaTransformacaoTool,
  // /**
  //  * COLP
  //  */
  // IodonegativoTool,
  // PadroesMosaicoTool,
  // PontuacoesTool,
  // RegioesAcetowhiteTool,
  // VascularizacaoAnormalTool,
  // /**
  //  * GLAU
  //  */
  // AtrofiaTool,
  // CopoOticoTool,
  // DiscoOticoTool,
  // NervoOticoTool,
  // TesteGlaucomaTool,
  // /**
  //  * OTHER
  //  */
  // // VerticalLineTool,
  // // HorizontalLineTool,
  // // ClockTool,
  // DefaultTool,
  // ~ Segmentation Tools
  // BrushTool,
  // SphericalBrushTool,
  // RectangleScissorsTool,
  // FreehandScissorsTool,
  // CircleScissorsTool,
  // CorrectionScissorsTool,
  // ~ Tools
  // CrosshairsTool,
  // DoubleTapFitToWindowTool,
  DragProbeTool,
  EraserTool,
  // FreehandRoiSculptorTool,
  MagnifyTool,
  // OverlayTool,
  // OrientationMarkersTool,
  // PanMultiTouchTool,
  PanTool,
  // ReferenceLinesTool,
  RotateTool,
  // RotateTouchTool,
  // ScaleOverlayTool,
  // StackScrollMouseWheelTool,
  // StackScrollMultiTouchTool,
  // StackScrollTool,
  // WwwcRegionTool,
  WwwcTool,
  ZoomMouseWheelTool,
  ZoomTool,
  // ZoomTouchPinchTool,
  init,
  stackPrefetch,
  stackRenderers,
  playClip,
  stopClip,
  store,
  getModule,
  getToolForElement,
  addTool,
  addToolForElement,
  removeTool,
  removeToolForElement,
  setToolOptions,
  setToolOptionsForElement,
  isToolActiveForElement,
  setToolActive,
  setToolActiveForElement,
  setToolEnabled,
  setToolEnabledForElement,
  setToolDisabled,
  setToolDisabledForElement,
  setToolPassive,
  setToolPassiveForElement,
  addToolState,
  getToolState,
  removeToolState,
  clearToolState,
  setElementToolStateManager,
  getElementToolStateManager,
  textStyle,
  toolStyle,
  toolColors,
  toolCoordinates,
  numberOfAnnotations,
  activeIndex,
  activeAnnotation,
  movingAnnotations,
  comparingImages,
  stackSpecificStateManager,
  newStackSpecificToolStateManager,
  addStackStateManager,
  loadHandlerManager,
  newImageIdSpecificToolStateManager,
  globalImageIdSpecificToolStateManager,
  newFrameOfReferenceSpecificToolStateManager,
  globalFrameOfReferenceSpecificToolStateManager,
  forceEnabledElementResize,
  orientation,
  SaveAs,
  enableLogger,
  disableLogger,
  register,
  registerSome,
  wwwcSynchronizer,
  updateImageSynchronizer,
  Synchronizer,
  stackScrollSynchronizer,
  stackImagePositionSynchronizer,
  stackImagePositionOffsetSynchronizer,
  stackImageIndexSynchronizer,
  panZoomSynchronizer,
  requestPoolManager,
  importInternal,
  external,
  EVENTS,
  version,
};

export { default as import } from './importInternal.js';

export default cornerstoneTools;
